var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.802,
    height: 95.1,
    viewBox: "0 0 108.802 95.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(-2 -5.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    transform: "translate(45.404 5.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M23.415,72.922a2.266,2.266,0,0,1-2.267-2.267V7.289a2.265,2.265,0,0,1,2.267-2.267H40.878a2.265,2.265,0,0,1,2.267,2.267V70.655a2.266,2.266,0,0,1-3.659,1.789l-7.34-5.716-7.338,5.715A2.257,2.257,0,0,1,23.415,72.922Zm8.73-11.334a2.263,2.263,0,0,1,1.392.478l5.074,3.951V9.556H25.682v56.46l5.071-3.949A2.264,2.264,0,0,1,32.146,61.588Z",
    transform: "translate(-21.148 -5.022)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396",
    transform: "translate(2 5.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M47.671,31.278H4.267A2.265,2.265,0,0,1,2,29.011V14.089a9.076,9.076,0,0,1,9.067-9.067h36.6a2.265,2.265,0,0,1,2.267,2.267V29.011A2.265,2.265,0,0,1,47.671,31.278ZM6.533,26.744H45.4V9.556H11.067a4.539,4.539,0,0,0-4.533,4.533Z",
    transform: "translate(-2 -5.022)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395",
    transform: "translate(60.867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M74.521,31.278h-43.4a2.265,2.265,0,0,1-2.267-2.267V7.289a2.265,2.265,0,0,1,2.267-2.267h36.6a9.076,9.076,0,0,1,9.067,9.067V29.011A2.266,2.266,0,0,1,74.521,31.278ZM33.386,26.744H72.254V14.089a4.539,4.539,0,0,0-4.533-4.533H33.386Z",
    transform: "translate(-28.853 -5.022)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397",
    transform: "translate(8.012 26.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M94.632,87.984H11.452a6.808,6.808,0,0,1-6.8-6.8V16.872a2.265,2.265,0,0,1,2.267-2.267H44.311a2.265,2.265,0,0,1,2.267,2.267v37l5.071-3.949a2.266,2.266,0,0,1,2.785,0l5.074,3.951V16.872a2.265,2.265,0,0,1,2.267-2.267H99.166a2.265,2.265,0,0,1,2.267,2.267V81.184A6.808,6.808,0,0,1,94.632,87.984ZM9.186,19.139V81.184a2.268,2.268,0,0,0,2.267,2.267h83.18A2.268,2.268,0,0,0,96.9,81.184V19.139H64.041V58.517a2.266,2.266,0,0,1-3.659,1.789l-7.34-5.716L45.7,60.3a2.266,2.266,0,0,1-3.659-1.789V19.139Z",
    transform: "translate(-4.652 -14.606)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingData);
export default __webpack_public_path__ + "static/media/loading-data.c0c22d2b6ff2c622c8ed53baaff5bd87.svg";
export { ForwardRef as ReactComponent };